var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.9996V7.35748C13 4.87007 11.6252 3.71268 9.79225 3.71268C8.31309 3.71268 7.65009 4.49853 7.28081 5.05015V3.90296H4.49394C4.53091 4.66292 4.49394 11.9996 4.49394 11.9996H7.28081V7.47793C7.28081 7.23664 7.29869 6.99457 7.37263 6.82194C7.57372 6.33819 8.03238 5.83757 8.80181 5.83757C9.81053 5.83757 10.2135 6.57987 10.2135 7.66821V12L13 11.9996ZM1.55797 2.79775C2.52931 2.79775 3.13503 2.17551 3.13503 1.39829C3.11716 0.604198 2.52972 0 1.57666 0C0.623594 0 0 0.603806 0 1.39829C0 2.17551 0.604906 2.79775 1.5405 2.79775H1.55797ZM2.95141 11.9996V3.90296H0.164937V11.9996H2.95141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.7f707297e67b5c21d354c4f85055a6c0.svg";
export { ForwardRef as ReactComponent };